var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"checkbox-wrapper"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isChecked},on:{"change":_vm.toggle}}),_c('span',{staticClass:"checkbox",class:_vm.stateClass})])}
var staticRenderFns = []

export { render, staticRenderFns }